export const prefix = `sim`;